import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IMuneerOptions } from '../interfaces/Muneer';
import { ApiCallerService } from './api-caller.service';

@Injectable({
  providedIn: 'root',
})
export class MuneerService {
  private isScriptLoaded = false;

  public muneerOptions: IMuneerOptions = {} as IMuneerOptions;
  constructor(private apiCallerService: ApiCallerService) {}

  loadMuneerScript(): void {
    if (!this.isScriptLoaded) {
      const script = document.createElement('script');
      // script.src = "assets/styles/components/muneer.min.js";
      script.async = true;
      script.onload = () => {

        // Ensure muneerOptions exists and store it in the public variable
        this.muneerOptions = (window as any).muneerOptions || {};
        // this.initMuneer();
      };
      document.body.appendChild(script);
      this.isScriptLoaded = true;
    }
  }

  initMuneer(): void {
    if (typeof (window as any).Muneer !== 'undefined') {
      (window as any).muneerOptions({
        path: `https://muneer.cx/static/v1/`,
      });
      // this.apiCallerService.put((window as any).muneerOptions.path)
    } else {
      console.error('Muneer script not loaded yet.');
    }
  }

  // updateMuneerOption(key: string, value: any): void {
  //   if (this.muneerOptions) {
  //     this.muneerOptions[key] = value;
  //     (window as any).muneerOptions = this.muneerOptions; // Update global object
  //   } else {
  //     console.error('muneerOptions is not initialized yet.');
  //   }
  // }

  updateMuneerOption(): void {
    if (this.muneerOptions) {
      (window as any).muneerOptions = this.muneerOptions; // Update global object
    } else {
      console.error('muneerOptions is not initialized yet.');
    }
  }
}
